import { render, staticRenderFns } from "./SignInButton.vue?vue&type=template&id=a8282752&scoped=true&"
import script from "./SignInButton.vue?vue&type=script&lang=ts&"
export * from "./SignInButton.vue?vue&type=script&lang=ts&"
import style0 from "./SignInButton.vue?vue&type=style&index=0&id=a8282752&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8282752",
  null
  
)

export default component.exports